import * as auth from '../../../apis/auth'
import * as cookies from '../../../utilties/cookies'
import { hideModal, refreshIntlLocale, startSaving, stopSaving } from '../core'
import queryString from 'query-string'
import history from '../../../utilties/history'
import { AuthErrorActions, AuthErrors } from '../../../apis/base'
import { utilityLog, syncCookies } from '../../../utilties/utilities'

const SIGN_IN_REQUESTED = 'SIGN_IN_REQUESTED'
const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'
const SIGN_IN_FAILED = 'SIGN_IN_FAILED'

export const signIn = (email, password, rememberMe, returnUrl, language) => (dispatch) => {
	dispatch({ type: SIGN_IN_REQUESTED, data: {} })
	return auth.signIn(email, password, rememberMe, language).then((response) => {
		syncCookies();
		if (response && response.isSuccessful) {
			let result = dispatch({ type: SIGN_IN_SUCCESS, data: response.user })
			// patients.setPatientPushToken(
			// 	window.localStorage.getItem('deviceId'),
			// 	window.localStorage.getItem('expoToken')
			// )
			let redirectUrl = `/`
			if (
				response.user &&
				response.user.surveyId &&
				response.user.surveyInstanceId &&
				response.user.caseId &&
				response.user.protocolId
			) {
				redirectUrl = `/survey/${response.user.caseId}/${response.user.protocolId}/${response.user.surveyInstanceId}/${response.user.surveyId}`
			} else if (returnUrl) {
				redirectUrl = returnUrl
			}
			history.push(redirectUrl, true)

			return result
		} else {
			if (response) {
				switch (response.errorCode) {
					case 22:
						return dispatch({ type: 'PHONE_VERIFICATION_CODE_SUCCESS', data: response.verifyPhone });
						break;
				}
			}

            cookies.remove('user')

			dispatch({ type: SIGN_IN_FAILED, data: response.user })
            return dispatch({
				type: 'SET_SNACKBAR_MESSAGE',
				data: { message: 'app.login.error', isSuccess: false }
			})
		}
	})
}

const COMPLETE_SIGN_IN_PHONE_VERIFICATION_REQUESTED = 'COMPLETE_SIGN_IN_PHONE_VERIFICATION_REQUESTED'
const COMPLETE_SIGN_IN_PHONE_VERIFICATION_SUCCESS = 'COMPLETE_SIGN_IN_PHONE_VERIFICATION_SUCCESS'
const COMPLETE_SIGN_IN_PHONE_VERIFICATION_FAILED = 'COMPLETE_SIGN_IN_PHONE_VERIFICATION_FAILED'

export const completeSignInPhoneVerification = (code, returnUrl) => (dispatch, getState) => {
    dispatch({ type: COMPLETE_SIGN_IN_PHONE_VERIFICATION_REQUESTED, data: {} })

    dispatch(startSaving());

    let state = getState();

    return auth.completePhoneVerification(code, state.user.verifyPhoneMask.rawData)
        .then((response) => {
			syncCookies();
            dispatch(stopSaving());

            if (response && response.isSuccessful) {
				let result = dispatch({ type: SIGN_IN_SUCCESS, data: response.user })

				let redirectUrl = '/dashboard'
                if (returnUrl) {
                    redirectUrl = returnUrl
				}

				history.push(redirectUrl, true)

                return result

            } else {

                if (response) {
                    switch (response.errorCode) {
                    case 23:
                        dispatch({
                            type: 'SET_SNACKBAR_MESSAGE',
                            data: {
                                message: `app.security.mfa.failed.invalidCode`,
                                isSuccess: false
                            }
                        })
                        break;
                    }
                }

                return dispatch({ type: COMPLETE_SIGN_IN_PHONE_VERIFICATION_FAILED, data: {} })
            }
        })
}

const SIGN_OUT_REQUESTED = 'SIGN_OUT_REQUESTED'
const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS'
//const SIGN_OUT_FAILED = 'SIGN_OUT_FAILED'

export const signOut = (returnUrl, doNotRedirect) => (dispatch) => {
	dispatch({ type: SIGN_OUT_REQUESTED, data: {} })
	localStorage.removeItem('user')
	return auth.signOut().then((response) => {
		syncCookies();
		if(!doNotRedirect) {
			history.push(`/auth/login${returnUrl ? '?returnUrl=' + returnUrl : ''}`, true)
		}
		
		return dispatch({ type: SIGN_OUT_SUCCESS, data: {} })
	})
}

const HOME_REQUESTED = 'HOME_REQUESTED'
const HOME_SUCCESS = 'HOME_SUCCESS'

export const home = () => (dispatch) => {
	dispatch({ type: HOME_REQUESTED, data: {} })
	
	history.push('/')

	return dispatch({ type: HOME_SUCCESS, data: {} })
}

const RESET_FAILED_AUTHENTICATION_REQUESTED = 'RESET_FAILED_AUTHENTICATION_REQUESTED'
const RESET_FAILED_AUTHENTICATION_SUCCESS = 'RESET_FAILED_AUTHENTICATION_SUCCESS'

export const resetFailedLogin = (email, password) => (dispatch) => {
	dispatch({ type: RESET_FAILED_AUTHENTICATION_REQUESTED, data: {} })

	return
}

const RESET_WRONG_CODE_ERROR_REQUESTED = 'RESET_WRONG_CODE_ERROR_REQUESTED'
const RESET_WRONG_CODE_ERROR_SUCCESS = 'RESET_WRONG_CODE_ERROR_SUCCESS'

export const resetWrongCodeError = () => (dispatch) => {
	dispatch({ type: RESET_WRONG_CODE_ERROR_REQUESTED, data: {} })

	return
}

const CONFIRM_FORGOT_PASSWORD_EMAIL_REQUESTED = 'CONFIRM_FORGOT_PASSWORD_EMAIL_REQUESTED'
const CONFIRM_FORGOT_PASSWORD_EMAIL_SUCCESS = 'CONFIRM_FORGOT_PASSWORD_EMAIL_SUCCESS'
const CONFIRM_FORGOT_PASSWORD_EMAIL_FAILED = 'CONFIRM_FORGOT_PASSWORD_EMAIL_FAILED'

export const confirmForgotPasswordEmail = (email, code, password) => (dispatch) => {
	dispatch({ type: CONFIRM_FORGOT_PASSWORD_EMAIL_REQUESTED, data: {} })
	return auth.confirmForgotPassword(email, code, password).then((response) => {
		if (response && response.isSuccessful === true) {
			dispatch({
				type: 'SET_SNACKBAR_MESSAGE',
				data: { message: 'app.confirmPassword.success', isSuccess: true }
			})
			
			history.push('/auth/login', true)

			return dispatch({ type: CONFIRM_FORGOT_PASSWORD_EMAIL_SUCCESS, data: { confirmedSuccessfully: true } })
		} else {
			dispatch({
				type: 'SET_SNACKBAR_MESSAGE',
				data: { message: 'app.confirmPassword.error', isSuccess: false }
			})

			return dispatch({ type: CONFIRM_FORGOT_PASSWORD_EMAIL_FAILED, data: { wrongCode: response.errorCode === 14 } })
		}
	})
}

const FORGOT_PASSWORD_EMAIL_REQUESTED = 'FORGOT_PASSWORD_EMAIL_REQUESTED'
const FORGOT_PASSWORD_EMAIL_SUCCESS = 'FORGOT_PASSWORD_EMAIL_SUCCESS'
const FORGOT_PASSWORD_EMAIL_FAILED = 'FORGOT_PASSWORD_EMAIL_FAILED'

export const requestForgotPasswordEmail = (email) => (dispatch) => {
	dispatch({ type: FORGOT_PASSWORD_EMAIL_REQUESTED, data: {} })
	return auth
		.requestForgotPasswordEmail(email)
		.then((response) => {
			if (!response || !response.ok) {
				return dispatch({
					type: 'SET_SNACKBAR_MESSAGE',
					data: { message: 'app.errorMessages.2', isSuccess: false }
				})
			} else return response.json()
		})
		.then((result) => {
			if (result && result.isSuccessful) {
				dispatch({
					type: 'SET_SNACKBAR_MESSAGE',
					data: { message: 'app.forgotPassword.emailSuccess', isSuccess: true }
				})

				history.push('/auth/confirmpassword?email=' + encodeURIComponent(email?.trim()), true)

				return dispatch({ type: FORGOT_PASSWORD_EMAIL_SUCCESS, data: { requestedSuccessfully: true } })
			} else {
				return dispatch({
					type: 'SET_SNACKBAR_MESSAGE',
					data: { message: 'app.forgotPassword.error', isSuccess: false }
				})
			}
		})
}

const REGISTER_USER_REQUESTED = 'REGISTER_USER_REQUESTED'
const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS'
const REGISTER_USER_FAILED = 'REGISTER_USER_FAILED'

export const registerUser = (email, password, rememberMe, language, token, originalEmail) => (dispatch) => {
	dispatch({ type: REGISTER_USER_REQUESTED, data: {} })
	return auth.registerUser(email, password, rememberMe, language, token, originalEmail).then((response) => {
		syncCookies();
		if (response && response.isSuccessful === true) {
			dispatch({ type: REGISTER_USER_SUCCESS, data: {} })
			dispatch(refreshIntlLocale())

			history.push(`/auth/welcome`, true)

			return dispatch({ type: 'FETCH_PATIENT_SUCCESS', data: response })
		} else {
			dispatch({ type: REGISTER_USER_FAILED, data: {} })
			if (response.errorCode === 6) {
				return dispatch({
					type: 'SET_SNACKBAR_MESSAGE',
					data: { message: 'app.registration.duplicateUser', isSuccess: false }
				})
			}
			return dispatch({
				type: 'SET_SNACKBAR_MESSAGE',
				data: { message: 'app.registration.failToRegister', isSuccess: false }
			})
		}
	})
}

const RESET_REGISTRATION_STATUS_REQUESTED = 'RESET_REGISTRATION_STATUS_REQUESTED'

export const resetRegistrationStatus = () => (dispatch) => {
	return dispatch({ type: RESET_REGISTRATION_STATUS_REQUESTED, data: null })
}

const VERIFICATION_CODE_REQUESTED = 'VERIFICATION_CODE_REQUESTED'
const VERIFICATION_CODE_SUCCESS = 'VERIFICATION_CODE_SUCCESS'
const VERIFICATION_CODE_FAILED = 'VERIFICATION_CODE_FAILED'

export const sendVerificationCode = (email, language) => (dispatch, getState) => {
	var state = getState()
	var currentStatus = state.auth?.registrationStatus

	if (currentStatus === 1) {
		dispatch({ type: VERIFICATION_CODE_REQUESTED, data: {} })
		return auth.sendVerificationCode(email, language).then((response) => {
			syncCookies();
			if (response && response.isSuccessful === true) {
				dispatch(refreshIntlLocale())
				dispatch(getRegistrationStatus(email))

				return dispatch({ type: VERIFICATION_CODE_SUCCESS, data: {} })
			} else {
				if (!!response)
				{
					if (response.errorCode === 6) {
						dispatch({
							type: 'SET_SNACKBAR_MESSAGE',
							data: { message: 'app.registration.duplicateUser', isSuccess: false }
						})
						return dispatch({ type: VERIFICATION_CODE_FAILED, data: {} })
					}
				}
				dispatch({
					type: 'SET_SNACKBAR_MESSAGE',
					data: { message: 'app.registration.failToRegister', isSuccess: false }
				})
				return dispatch({ type: VERIFICATION_CODE_FAILED, data: {} })
			}
		})
	}
	else if (currentStatus === 2) {
		dispatch({ type: VERIFICATION_CODE_REQUESTED, data: {} })
		return auth.resendVerificationCode(email).then((response) => {
			if (response && response.isSuccessful === true) {
				dispatch(getRegistrationStatus(email))

				return dispatch({ type: VERIFICATION_CODE_SUCCESS, data: {} })
			} else {
				dispatch({
					type: 'SET_SNACKBAR_MESSAGE',
					data: { message: 'app.accessCode.sendError', isSuccess: false }
				})
				return dispatch({ type: VERIFICATION_CODE_FAILED, data: {} })
			}
		})
	}
}

const RESET_VERIFICATION_CODE_COUNTDOWN_REQUESTED = 'RESET_VERIFICATION_CODE_COUNTDOWN_REQUESTED'
export const resetVerificationCodeCountDown = () => (dispatch) => {
	dispatch({ type: RESET_VERIFICATION_CODE_COUNTDOWN_REQUESTED, data: {} })
}


const CONFIRM_CODE_REQUESTED = 'CONFIRM_CODE_REQUESTED'
const CONFIRM_CODE_SUCCESS = 'CONFIRM_CODE_SUCCESS'
const CONFIRM_CODE_FAILED = 'CONFIRM_CODE_FAILED'

export const confirmCode = (email, code) => (dispatch) => {
	if (email?.length > 0 && code?.length > 0) {
		dispatch({ type: CONFIRM_CODE_REQUESTED, data: {} })
		return auth.confirmCode(email, code).then((response) => {
			if (response && response.isSuccessful === true) {
				var encodedEmail = encodeURIComponent(email)

				history.push(`/auth/register?email=${encodedEmail}`, true)
			} else {
				return dispatch({
					type: 'SET_SNACKBAR_MESSAGE',
					data: { message: 'app.accessCode.incorrectCode', isSuccess: false }
				})
			}
		})
	}
}

const SETUP_PASSWORD_REQUESTED = 'SETUP_PASSWORD_REQUESTED'
const SETUP_PASSWORD_SUCCESS = 'SETUP_PASSWORD_SUCCESS'
const SETUP_PASSWORD_FAILED = 'SETUP_PASSWORD_FAILED'

export const setupPassword = (verificationCode, email, password, rememberMe, language) => (dispatch) => {
	dispatch({ type: SETUP_PASSWORD_REQUESTED, data: {} })
	return auth.setupPassword(verificationCode, email, password, rememberMe, language).then((response) => {
		syncCookies();
		if (response && response.isSuccessful === true) {
			dispatch(refreshIntlLocale())

			var query = queryString.parse(window.location.search)
			var queryData = !!query.data ? encodeURIComponent(query.data) : undefined

			history.push(`/auth/welcome${queryData ? `?data=${queryData}` : ""}`, true)

			return dispatch({ type: 'FETCH_PATIENT_SUCCESS', data: response })
		} else {
			dispatch({ type: SETUP_PASSWORD_FAILED, data: {} })
			if (response && response.errorCode == 23)
			{
				return dispatch({
					type: 'SET_SNACKBAR_MESSAGE',
					data: { message: 'app.security.invalidCode', isSuccess: false }
				})
			}
			else {
				return dispatch({
					type: 'SET_SNACKBAR_MESSAGE',
					data: { message: 'app.registration.failToRegister', isSuccess: false }
				})
			}
		}
	})
}

const REFRESH_TOKEN_REQUESTED = 'REFRESH_TOKEN_REQUESTED'
const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS'
const REFRESH_TOKEN_FAILED = 'REFRESH_TOKEN_FAILED'

export const refreshToken = () => (dispatch) => {
    dispatch({ type: REFRESH_TOKEN_REQUESTED, data: {} })

	utilityLog("Refreshing token by request", 2);
    return auth.refreshToken().then((response) => {
		syncCookies();
        if (response && response.isSuccessful) {
            return dispatch({ type: REFRESH_TOKEN_SUCCESS })
        } else {
            return dispatch({ type: REFRESH_TOKEN_FAILED })

            return dispatch({
                type: 'SET_SNACKBAR_MESSAGE',
                data: { message: 'app.general.failed', isSuccess: false }
            })
        }
    })
}

const SELF_REGISTER_USER_REQUESTED = 'SELF_REGISTER_USER_REQUESTED'
const SELF_REGISTER_USER_SUCCESS = 'SELF_REGISTER_USER_SUCCESS'
const SELF_REGISTER_USER_FAILED = 'SELF_REGISTER_USER_FAILED'

export const selfRegisterUser = (email, search, language) => (dispatch, getSate) => {
	const state = getSate()

	dispatch({ type: SELF_REGISTER_USER_REQUESTED, data: {} })
	return auth.selfRegisterUser(email, search, language).then((response) => {
		syncCookies();
		if (response && response.isSuccessful === true) {
			if (state.auth.registrationStatus === 0) {
				dispatch(getRegistrationStatus(email))
			}
			dispatch({ type: SELF_REGISTER_USER_SUCCESS, data: {} })
			
			return dispatch({ type: 'FETCH_PATIENT_SUCCESS', data: response })
		} else {
			console.log('errorCode')
			console.log(response.errorCode)
			dispatch({ type: SELF_REGISTER_USER_FAILED, data: {} })
			if (response.errorCode === 6) {
				history.push(`/auth/login?email=${encodeURIComponent(email)}`, true)

				return dispatch({
					type: 'SET_SNACKBAR_MESSAGE',
					data: { message: 'app.registration.duplicateUser', isSuccess: false }
				})
			} else if (response.errorCode === 13) {
				return dispatch({
					type: 'SET_SNACKBAR_MESSAGE',
					data: { message: 'app.registration.caseLimitReached', isSuccess: false }
				})
			}
			return dispatch({
				type: 'SET_SNACKBAR_MESSAGE',
				data: { message: 'app.registration.failToRegister', isSuccess: false }
			})
		}
	})
}

const CONFIRM_REGISTRATION_REQUESTED = 'CONFIRM_REGISTRATION_REQUESTED'
const CONFIRM_REGISTRATION_SUCCESS = 'CONFIRM_REGISTRATION_SUCCESS'
const CONFIRM_REGISTRATION_FAILED = 'CONFIRM_REGISTRATION_FAILED'

export const confirmUser = (code, email, history) => (dispatch) => {
	dispatch({ type: CONFIRM_REGISTRATION_REQUESTED, data: {} })

	return auth.confirmUser(email, code).then((response) => {
		syncCookies();
		if (response && response.isSuccessful === true) {
			history.push('/auth/login', true)

			return dispatch({
				type: 'SET_SNACKBAR_MESSAGE',
				data: { message: 'app.onboarding.confirmSuccessMessage', isSuccess: true }
			})
		} else {
			return dispatch({
				type: 'SET_SNACKBAR_MESSAGE',
				data: { message: 'app.onboarding.confirmFailMessage', isSuccess: false }
			})
		}
	})
}

const RESEND_CONFIRMATION_CODE_REQUESTED = 'RESEND_CONFIRMATION_CODE_REQUESTED'
const RESEND_CONFIRMATION_CODE_SUCCESS = 'RESEND_CONFIRMATION_CODE_SUCCESS'
const RESEND_CONFIRMATION_CODE_FAILED = 'RESEND_CONFIRMATION_CODE_FAILED'

export const resendConfirmationCode = (email, successMessage, failMessage) => (dispatch) => {
	dispatch({ type: RESEND_CONFIRMATION_CODE_REQUESTED, data: {} })

	var t = encodeURIComponent(email)
	return auth.resendConfirmationCode(encodeURIComponent(email)).then((response) => {
		syncCookies();
		if (response && response.ok === true) {
			dispatch({ type: 'SET_SNACKBAR_MESSAGE', data: { message: successMessage, isSuccess: true } })
			return dispatch({ type: RESEND_CONFIRMATION_CODE_SUCCESS, data: {} })
		} else {
			dispatch({ type: 'SET_SNACKBAR_MESSAGE', data: { message: failMessage, isSuccess: true } })
			return dispatch({ type: RESEND_CONFIRMATION_CODE_FAILED, data: {} })
		}
	})
}

const CHANGE_PASSWORD_REQUESTED = 'CHANGE_PASSWORD_REQUESTED'
const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
const CHANGE_PASSWORD_FAILED = 'CHANGE_PASSWORD_FAILED'

export const changePassword = (email, oldPassword, newPassword) => (dispatch) => {
	dispatch({ type: CHANGE_PASSWORD_REQUESTED, data: {} })

	return auth.changePassword(email, oldPassword, newPassword).then((response) => {
		if (response && response.isSuccessful) {
			dispatch(hideModal())
			dispatch({
				type: 'SET_SNACKBAR_MESSAGE',
				data: { message: 'app.changePassword.success', isSuccess: true }
			})
			return dispatch({ type: CHANGE_PASSWORD_SUCCESS, data: response.user })
		} else {
			if (response.errorCode === 16) {
				return dispatch({
					type: 'SET_SNACKBAR_MESSAGE',
					data: { message: 'app.changePassword.wrongPassword', isSuccess: false }
				})
			}
			return dispatch({
				type: 'SET_SNACKBAR_MESSAGE',
				data: { message: 'app.general.failed', isSuccess: false }
			})
		}
	})
}

const EXTERNAL_AUTH_REQUESTED = 'EXTERNAL_AUTH_REQUESTED'
const EXTERNAL_AUTH_SUCCESS = 'EXTERNAL_AUTH_SUCCESS'
const EXTERNAL_AUTH_FAILED = 'EXTERNAL_AUTH_FAILED'

export const externalAuth = (data) => (dispatch, getState) => {
	dispatch({ type: EXTERNAL_AUTH_REQUESTED, data: {} })

	return auth.externalAuth(data).then((response) => {
		syncCookies();
		if (response && response.isSuccessful === true) {
			let user = cookies.get('user')

			let result = dispatch({ type: EXTERNAL_AUTH_SUCCESS, data: user })

			history.push('/scores', true)

			return result
		} else if (!!response && AuthErrors.includes(parseInt(response.errorCode))) {
			dispatch({
				type: 'SHOW_AUTH_ERROR_DIALOG',
				data: {
					options: {
						buttonUrl: response.redirectTo,
						authErrorCode: response.errorCode,
						disableBackdropClick: true
					}
				}
			})

			return dispatch({ type: EXTERNAL_AUTH_FAILED, data: {} })
		} else {
			dispatch({
				type: 'SET_SNACKBAR_MESSAGE',
				data: { message: 'app.login.error', isSuccess: false }
			})

			return dispatch({ type: EXTERNAL_AUTH_FAILED, data: { wrongCode: response.errorCode === 14 } })
		}
	})
}

const AUTO_SIGN_IN_REQUESTED = 'AUTO_SIGN_IN_REQUESTED'
const AUTO_SIGN_IN_SUCCESS = 'AUTO_SIGN_IN_SUCCESS'
const AUTO_SIGN_IN_FAILED = 'AUTO_SIGN_IN_FAILED'

export const autoSignIn = (patient, token, returnUrl) => (dispatch) => {
	dispatch({ type: AUTO_SIGN_IN_REQUESTED, data: {} })
	return auth.autoSignIn(patient, token).then((response) => {
		syncCookies();
		if (response && response.isSuccessful) {
			let result = dispatch({ type: AUTO_SIGN_IN_SUCCESS, data: response.user })

			let redirectUrl = `/`			
			if (returnUrl) {
				redirectUrl = returnUrl
			} else if (response.redirectTo) {
				redirectUrl = response.redirectTo
			} else if (
				response.user &&
				response.user.surveyId &&
				response.user.surveyInstanceId &&
				response.user.caseId &&
				response.user.protocolId
			) {
				redirectUrl = `/survey/${response.user.caseId}/${response.user.protocolId}/${response.user.surveyInstanceId}/${response.user.surveyId}`
			}

			history.push(redirectUrl, true)

			return result
		} else if (response && response.redirectTo) {
			let result = dispatch({ type: AUTO_SIGN_IN_FAILED, data: { linkExpired: response.linkExpired } })

			var query = queryString.parse(window.location.search)
			var token = query.token
			var urlHasParams = response.redirectTo.indexOf('?') > 0
			var redirectTo = response.linkExpired ? response.redirectTo : `${response.redirectTo}${!!token ? `${urlHasParams ? '&' : '?'}token=${token}` : ''}`
		
			history.push(redirectTo, true)

			return result
		} else {
			dispatch({ type: AUTO_SIGN_IN_FAILED, data: { linkExpired: response.linkExpired } })

			cookies.remove('user')
			return dispatch({
				type: 'SET_SNACKBAR_MESSAGE',
				data: { message: 'app.login.error', isSuccess: false }
			})
		}
	})
}

const CHECK_EMAIL_REQUESTED = 'CHECK_EMAIL_REQUESTED'
const CHECK_EMAIL_SUCCESS = 'CHECK_EMAIL_SUCCESS'
const CHECK_EMAIL_FAILED = 'CHECK_EMAIL_FAILED'

export const checkEmail = (email) => (dispatch) => {
	dispatch({ type: CHECK_EMAIL_REQUESTED, data: {} })
	return auth.checkEmail(email).then((response) => {
		if (response && response.isSuccessful) {
			return dispatch({ type: CHECK_EMAIL_SUCCESS, data: response.status })
		}

		return dispatch({ type: CHECK_EMAIL_FAILED, data: {} })
	})
}

const RESET_EMAIL_STATUS_REQUESTED = 'RESET_EMAIL_STATUS_REQUESTED'

export const resetEmailStatus = () => (dispatch) => {
	return dispatch({ type: RESET_EMAIL_STATUS_REQUESTED, data: {} })
}

const REGISTRATION_STATUS_REQUESTED = 'REGISTRATION_STATUS_REQUESTED'
const REGISTRATION_STATUS_SUCCESS = 'REGISTRATION_STATUS_SUCCESS'
const REGISTRATION_STATUS_FAILED = 'REGISTRATION_STATUS_FAILED'

export const getRegistrationStatus = (email, token = null) => (dispatch) => {
	var currentPath = window.location.pathname + window.location.search
	var newPath

	var query = queryString.parse(window.location.search)
	var queryEmail = query.email;
	var queryData = !!query.data ? encodeURIComponent(query.data) : undefined

	var encodedEmail = encodeURIComponent(email)

	dispatch({ type: REGISTRATION_STATUS_REQUESTED, data: {} })
	if (
		!email?.length
		&& queryData?.length > 0
	) {
		newPath = `/auth/emailVerification?data=${queryData}`
		if (currentPath != newPath) {
			history.push(newPath, true)
		}
	}
	else {
		return auth.getRegistrationStatus(email, token).then((response) => {
			if (response && response.isSuccessful) {
				switch (response.registrationStatus)
				{
					case 0:
						if (!queryData) {
							newPath = `/auth/login`
						}
						break
					case 1:
						newPath = `/auth/emailVerification?${!queryData ? `email=${encodedEmail}` : `data=${queryData}`}`
						break
					case 2:
						newPath = `/auth/register?email=${encodedEmail}${!!token ? `&token=${token}` : ''}${queryData ? `&data=${queryData}` : ''}`
						break
					case 3:
						if (queryData) {
							newPath = `/auth/selfRegister?email=${encodedEmail}&data=${queryData}`
						}
						else {
							newPath = `/auth/register?email=${encodedEmail}${!!token ? `&token=${token}` : ''}${queryData ? `&data=${queryData}` : ''}`
						}
						break
					case 4:
					case 5:
						newPath = `/auth/login?email=${encodedEmail}`
						break
					case 6:
						if (queryData) {
							newPath = `/auth/selfRegister?email=${encodedEmail}&data=${queryData}`
						}
						else {
							newPath = `/auth/register?email=${encodedEmail}${!!token ? `&token=${token}` : ''}`
						}
						break
					default:
						break
				}

				if (
					!!newPath
					&& currentPath != newPath
				) {
					history.push(newPath, true)
				}

				return dispatch({ type: REGISTRATION_STATUS_SUCCESS, data: response.registrationStatus })
			}
	
			return dispatch({ type: REGISTRATION_STATUS_FAILED, data: {} })
		})
	}
}

export const getIsAuthorizedUser = (userId) => (dispatch) => {
	return auth.getIsAuthorizedUser(userId)
		.then(response => {
			if (
				!!response
				&& !response.isSuccessful
				&& AuthErrors.includes(parseInt(response.errorCode))
			) {
				dispatch({
					type: 'SHOW_AUTH_ERROR_DIALOG',
					data: {
						options: {
							buttonUrl: response.redirectTo,
							authErrorCode: response.errorCode,
							disableBackdropClick: true
						}
					}
				})
			}
		})
}


const initial = {
	isAuthorizationStarted: false,
	confirmed: false,
	error: false,
	failedLogin: false,
	requestedSuccessfully: null,
	requestPasswordStatus: null,
	confirmationResent: false,
	wrongCodeError: false,
    isTokenRefreshing: false,
	emailStatus: null,
	emailValidationInProgress: false,
	registrationStatus: null,
	isSaving: false,
	isVerificationCodeCountDown: false,
	linkExpired: false
}

export const reducer = (state = initial, action) => {
	switch (action.type) {
		case SIGN_IN_REQUESTED:
			return {
				...state,
				isAuthorizationStarted: true,
				linkExpired: false
			}
		case SIGN_IN_SUCCESS:
			return { 
				...state,
				user: action.data,
				isAuthorizationStarted: false,
				linkExpired: false
			 }
		case SIGN_IN_FAILED:
			return {
				...state,
				//failedLogin: true,
				isAuthorizationStarted: false,
			}
		case AUTO_SIGN_IN_REQUESTED:
			return {
				...state,
				isAuthorizationStarted: true,
				linkExpired: false
			}
		case AUTO_SIGN_IN_SUCCESS:
			return {
				...state,
				user: action.data,
				isAuthorizationStarted: false,
				linkExpired: false
		}
		case AUTO_SIGN_IN_FAILED:
			return {
				...state,
				failedLogin: true,
				isAuthorizationStarted: false,
				linkExpired: action.data.linkExpired
			}
		case EXTERNAL_AUTH_REQUESTED:
			return {
				...state,
				isAuthorizationStarted: true,
				linkExpired: false
			}
		case EXTERNAL_AUTH_SUCCESS:
			return {
				...state,
				isAuthorizationStarted: false,
				linkExpired: false,
				user: action.data
			}
		case EXTERNAL_AUTH_FAILED:
			return {
				...state,
				isAuthorizationStarted: false,
				linkExpired: action.data.linkExpired
			}
		case SELF_REGISTER_USER_REQUESTED:
		case REGISTER_USER_REQUESTED:
		case SETUP_PASSWORD_REQUESTED:
			return { ...state, isSaving: true }
		case SELF_REGISTER_USER_SUCCESS:
			return {
				...state,
				isSaving: false,
				isVerificationCodeCountDown: true
			}
		case REGISTER_USER_SUCCESS:
			return { ...state, isSaving: false }
		case SETUP_PASSWORD_FAILED:
		case REGISTER_USER_FAILED:		
		case SELF_REGISTER_USER_FAILED:
			return { ...state, error: true, isSaving: false  }
		case CONFIRM_REGISTRATION_SUCCESS:
			return { ...state, confirmationResent: true }
		case CONFIRM_REGISTRATION_SUCCESS:
			return { ...state, confirmed: true }
		case RESET_FAILED_AUTHENTICATION_REQUESTED:
			return { ...state, failedLogin: false }	
		case FORGOT_PASSWORD_EMAIL_SUCCESS:
			return { ...state }
		case RESET_WRONG_CODE_ERROR_REQUESTED:
			return {...state, wrongCodeError: false}
		case CONFIRM_FORGOT_PASSWORD_EMAIL_FAILED:
			return { ...state, wrongCodeError: action.data.wrongCode }
        case REFRESH_TOKEN_REQUESTED:
            return { ...state, isTokenRefreshing: true }
        case REFRESH_TOKEN_SUCCESS:
            return { ...state, isTokenRefreshing: false }
        case REFRESH_TOKEN_FAILED:
            return { ...state, isTokenRefreshing: false }
		case CHECK_EMAIL_REQUESTED:
			return { ...state, emailValidationInProgress: true }
		case CHECK_EMAIL_SUCCESS:
			return { ...state, emailStatus: action.data, emailValidationInProgress: false }
		case CHECK_EMAIL_FAILED:
			return { ...state, emailValidationInProgress: false }
		case RESET_EMAIL_STATUS_REQUESTED:
			return { ...state, emailStatus: null }
		case RESET_REGISTRATION_STATUS_REQUESTED:
		case REGISTRATION_STATUS_REQUESTED:
			return { ...state, registrationStatus: null }
		case REGISTRATION_STATUS_SUCCESS:
			return { ...state, registrationStatus: action.data }
		case VERIFICATION_CODE_REQUESTED:
			return {
				...state,
				isVerificationCodeCountDown: null
			}
		case VERIFICATION_CODE_SUCCESS:
			return {
				...state,
				isVerificationCodeCountDown: true
			}
		case VERIFICATION_CODE_FAILED:
		case RESET_VERIFICATION_CODE_COUNTDOWN_REQUESTED:
			return {
				...state,
				isVerificationCodeCountDown: false
			}
		default:
			return { ...state }
	}
}

export const confirmedSelector = (state) => {
	return state.auth.confirmed
}

export const errorSelector = (state) => {
	return state.auth.error
}

export const wrongCodeErrorSelector = (state) => {
	return state.auth.wrongCodeError
}

export const userSelector = (state) => {
	return state.auth.user
}

export const emailStatusSelector = (state) => {
	return state.auth.emailStatus
}

export const emailValidationInProgressSelector = (state) => {
	return state.auth.emailValidationInProgress
}
export const emailSelector = (state) => state.patient && state.patient.email

export const registrationStatusSelector = (state) => state.auth && state.auth.registrationStatus

export const registrationIsSavingSelector = (state) => state.auth && state.auth.isSaving

export const isVerificationCodeCountDownSelector = (state) => state.auth && state.auth.isVerificationCodeCountDown

export const isAuthorizationStartedSelector = (state) => state.auth && state.auth.isAuthorizationStarted
